<template>
  <div>
    <div class="page-header">
      <div class="page-header-index-wide">
        <a-breadcrumb class="breadcrumb">
          <a-breadcrumb-item>
            <router-link
              :to="{ path: '/' }"
            >首页</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>基础设置</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>App配置</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
        <div class="detail">
          <div class="main" >
            <div class="row">
              <h1 class="title">App配置</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ak-setting :options="options" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      options: [
        {
          title: '抢购规则',
          inputs: [
            {
              name: 'startTime',
              note: '开始时间',
              type: 'Date',
              showTime: true,
              validators: [
                (val) => val ? null : '开始时间不可为空'
              ]
            },
            {
              name: 'endTime',
              note: '结束时间',
              type: 'Date',
              showTime: true,
              validators: [
                (val) => val ? null : '结束时间不可为空'
              ]
            }
          ]
        },
        {
          title: '广告图片',
          inputs: [
            {
              name: 'appImage',
              note: '图片来源',
              type: 'Image',
              tooltip: '建议750px * 1334px',
              validators: [
                (val) => val ? null : '广告图片不可为空'
              ]
            }
          ]
        }, {
          title: '活动图片',
          inputs: [
            {
              name: 'eventPictures',
              note: '图片来源',
              type: 'Image',
              tooltip: '建议690px * 130px',
              validators: [
                (val) => val ? null : '活动图片不可为空'
              ]
            }
          ]
        }, {
          title: '会员规则',
          inputs: [
            {
              name: 'memberRule',
              note: '规则内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '会员规则不可为空'
              ]
            }
          ]
        }, {
          title: '用户声明',
          inputs: [
            {
              name: 'userAgreement',
              note: '声明内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '用户声明不可为空'
              ]
            }
          ]
        }, {
          title: '隐私政策',
          inputs: [
            {
              name: 'privacyPolicy',
              note: '政策内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '隐私政策不可为空'
              ]
            }
          ]
        }, {
          title: '联系我们',
          inputs: [
            {
              name: 'contactUs',
              note: '联系我们内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '联系我们不可为空'
              ]
            }
          ]
        }, {
          title: '关于我们',
          inputs: [
            {
              name: 'aboutUs',
              note: '关于我们内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '关于我们不可为空'
              ]
            }
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  .page-header {
    background: #fff;
    padding: 16px 32px 0;
    border-bottom: 1px solid #e8e8e8;
    margin: -24px -24px 24px -24px;
    .breadcrumb {
      margin-bottom: 16px;
    }
    .detail {
      display: flex;
      /*margin-bottom: 16px;*/
      .avatar {
        flex: 0 1 72px;
        margin: 0 24px 8px 0;
        & > span {
          border-radius: 72px;
          display: block;
          width: 72px;
          height: 72px;
        }
      }
      .main {
        width: 100%;
        flex: 0 1 auto;
        .row {
          display: flex;
          width: 100%;
          .avatar {
            margin-bottom: 16px;
          }
        }
        .title {
          font-size: 20px;
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 16px;
          flex: auto;
        }
        .logo {
          width: 28px;
          height: 28px;
          border-radius: 4px;
          margin-right: 16px;
        }
        .content,
        .headerContent {
          flex: auto;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
          .link {
            margin-top: 16px;
            line-height: 24px;
            a {
              font-size: 14px;
              margin-right: 32px;
            }
          }
        }
        .extra {
          flex: 0 1 auto;
          margin-left: 88px;
          min-width: 242px;
          text-align: right;
        }
        .action {
          margin-left: 56px;
          min-width: 266px;
          flex: 0 1 auto;
          text-align: right;
          &:empty {
            display: none;
          }
        }
      }
    }
  }
  .mobile .page-header {
    .main {
      .row {
        flex-wrap: wrap;
        .avatar {
          flex: 0 1 25%;
          margin: 0 2% 8px 0;
        }
        .content,
        .headerContent {
          flex: 0 1 70%;
          .link {
            margin-top: 16px;
            line-height: 24px;
            a {
              font-size: 14px;
              margin-right: 10px;
            }
          }
        }
        .extra {
          flex: 1 1 auto;
          margin-left: 0;
          min-width: 0;
          text-align: right;
        }
        .action {
          margin-left: unset;
          min-width: 266px;
          flex: 0 1 auto;
          text-align: left;
          margin-bottom: 12px;
          &:empty {
            display: none;
          }
        }
      }
    }
  }
</style>
